import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import VueAxios from "vue-axios"
import axios from "axios"
import moment from "moment"
import qs from "qs"
import "element-ui/lib/theme-chalk/icon.css"
import "./assets/iconfont.css"
import "./assets/iconfont/iconfont.css"
import {
  Drawer,
  CheckboxGroup,
  Button,
  Form,
  FormItem,
  Input,
  Icon,
  Select,
  Option,
  Message,
  Menu,
  MenuItem,
  Submenu,
  Tabs,
  TabPane,
  Row,
  Col,
  Table,
  Modal,
  Card,
  Page,
  Layout,
  Sider,
  Header,
  Content,
  Poptip,
  Upload,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DatePicker,
  RadioGroup,
  Radio,
  Spin,
  BackTop,
  TimePicker,
  ButtonGroup,
  Tooltip,
  Carousel,
  CarouselItem,
  Checkbox,
  Switch,
} from "view-design"
import cronParser from "cron-parser"

import NProgress from "nprogress"
import "nprogress/nprogress.css"
import "view-design/dist/styles/iview.css"

import * as echarts from "echarts"

import { getCookie } from "./common/utils"

import CKEditor from "@ckeditor/ckeditor5-vue2"

Vue.component("i-checkboxgroup", CheckboxGroup)
Vue.component("i-button", Button)
Vue.component("i-buttongroup", ButtonGroup)
Vue.component("i-form", Form)
Vue.component("i-formItem", FormItem)
Vue.component("i-input", Input)
Vue.component("i-icon", Icon)
Vue.component("i-select", Select)
Vue.component("i-option", Option)
Vue.component("i-menu", Menu)
Vue.component("i-menuItem", MenuItem)
Vue.component("i-submenu", Submenu)
Vue.component("i-tabs", Tabs)
Vue.component("i-tabPane", TabPane)
Vue.component("i-row", Row)
Vue.component("i-col", Col)
Vue.component("i-table", Table)
Vue.component("i-modal", Modal)
Vue.component("i-card", Card)
Vue.component("i-page", Page)
Vue.component("i-layout", Layout)
Vue.component("i-sider", Sider)
Vue.component("i-header", Header)
Vue.component("i-content", Content)
Vue.component("i-poptip", Poptip)
Vue.component("i-upload", Upload)
Vue.component("i-dropdown", Dropdown)
Vue.component("i-dropdownMenu", DropdownMenu)
Vue.component("i-dropdownItem", DropdownItem)
Vue.component("i-datePicker", DatePicker)
Vue.component("i-timePicker", TimePicker)
Vue.component("i-Radio-group", RadioGroup)
Vue.component("i-radio", Radio)
Vue.component("i-spin", Spin)
Vue.component("i-drawer", Drawer)
Vue.component("i-backTop", BackTop)
Vue.component("i-tooltip", Tooltip)
Vue.component("i-carousel", Carousel)
Vue.component("i-carouselItem", CarouselItem)
Vue.component("i-checkbox", Checkbox)
Vue.component("i-switch", Switch)
// Vue.component('i-tree',TreeSelect)

moment.locale("zh-cn", {
  longDateFormat: {
    llll: "YYYY-MM-DD HH:mm:ss",
  },
})

Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$cronParser = cronParser
Vue.prototype.$Message = Message
Vue.prototype.$Message.config({
  top: 50,
  duration: 2,
})

// axios 请求拦截器
axios.defaults.withCredentials = true
let resflag = true
axios.interceptors.request.use(
  (config) => {
    config.paramsSerializer = function(params) {
      for (let key in params) {
        if (typeof params[key] === "object") {
          if (!Array.isArray(params[key])) {
            params[key] = JSON.stringify(params[key])
          }
        }
      }
      return qs.stringify(params, { arrayFormat: "repeat" })
    }
    config.headers.common["X-CSRF-TOKEN"] = getCookie("csrf_access_token")
    config.withCredentials = true
    NProgress.start()
    return config
  },
  function(error) {
    return Promise.reject(error)
  },
)

// axios响应拦截器
axios.interceptors.response.use(
  (response) => {
    NProgress.done()
    console.log(response.data.code)
    if (response.data.code === -81) {
      console.log(response)
      if (resflag) {
        resflag = false
        Message.error("无权访问!")
        setTimeout(() => {
          resflag = true
        }, 1000)
      }
      router.go(-1)
      return false
    } else if (response.data.code === -82) {
      if (resflag) {
        resflag = false
        Message.error("认证失败!")
        setTimeout(() => {
          resflag = true
        }, 1000)
      }
      router.push({ path: "/login" }).catch((err) => err)
      return false
    } else {
      return response
    }
  },
  function(error) {
    return Promise.reject(error)
  },
)

Vue.use(CKEditor)
Vue.prototype.$Modal = Modal
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
